import { SolutionLanding } from "./SolutionLanding";

export default function LegalCourtBundles() {
  return (
    <SolutionLanding
      meta={{
        testid: "legal-landing-page",
        title: "WhatsApp Chat Conversion for E-Discovery | AuditPDF",
        description:
          "Produce verified, exhibit-ready WhatsApp chat PDFs for e-Discovery and court bundles. Secured by cryptographic integrity hashing and zero-retention architecture.",
        path: "/legal-court-bundles",
      }}
      hero={{
        eyebrow: "For Legal & E-Discovery Teams",
        headline: "Court-Ready WhatsApp Bundles in Seconds.",
        sub: "Instantly transform native .txt exports into verified, exhibit-ready PDFs—secured by an ephemeral, zero-retention architecture.",
      }}
      pain={{
        title: "Opposing legal teams will attack the weakest link in your production. Don't let it be formatting.",
        points: [
          {
            title: "Inadmissible screenshots",
            body: "Cropped images invite authenticity challenges: no hash, no completeness guarantee, and a broken chain of custody.",
          },
          {
            title: "Unverifiable transcripts",
            body: "Manually retyped chat logs cannot be tied back to the source file — leaving every character open to dispute.",
          },
          {
            title: "Unbillable Hours",
            body: "Legal executives burn hundreds of hours formatting unstructured data that our deterministic engine processes in minutes.",
          },
        ],
      }}
      solution={{
        title: "Exhibit-ready output, engineered for judicial scrutiny.",
        body: "AuditPDF utilizes a strict deterministic parsing engine to eliminate manual formatting errors. We perfectly reconstruct chat chronology into a universally readable document, backed by verifiable mathematical proof—without relying on any AI inference.",
        bullets: [
          "Cryptographic Chain of Custody: A SHA-256 fingerprint permanently binds the PDF to the exact source file.",
          "Court-Standard Formatting: Exhibit cover sheets with matter references, page counts, and automated participant schedules.",
          "Media Integrity Ledger: Every attachment is independently hashed and logged for verification.",
          "Relational Chronology Reconstruction: Perfect, chronological alignment of multi-media attachments and system events.",
        ],
        caseLabel: "EXHIBIT A-4",
      }}
      showAffidavit={true}
      workflowSteps={[
        {
          title: "Upload",
          body: "Submit the native WhatsApp ZIP export. The archive is cryptographically fingerprinted before processing begins.",
        },
        {
          title: "Process",
          body: "The data enters an isolated, ephemeral processing environment. Our engine renders every message deterministically with absolutely zero AI interpretation.",
        },
        {
          title: "Download & Purge",
          body: "Retrieve the complete exhibit and Affidavit of Authenticity via an expiring link. All source data is immediately purged via our strict zero-retention protocol.",
        },
      ]}
      finalCta={{
        headline: "Generate chat evidence that withstands scrutiny.",
        sub: "Stop burning unbillable hours on manual formatting. Secure your chain of custody today.",
      }}
      crossLink={{ to: "/hr-workplace-investigations", label: "For HR Teams" }}
    />
  );
}